import { defineStore } from 'pinia';
import { ImageService } from '../services';
import { Logger } from '../middlewares/sentry';

export const useGalleryStore = defineStore('coreGallery', {
  state: () => ({
    images: {},
    isExpandedAny: false,
    idExpandedImage: -1,
    isLoading: false,
  }),
  actions: {
    async loadImages() {
      const NUM_OF_IMGS = 20;
      let numAddedImages = -1;

      if (this.isLoading === false) {
        this.isLoading = true;
        const listOfNames = [];
        for (const img in this.images) {
          if (this.images.hasOwnProperty(img)) {
            listOfNames.push(img);
          }
        }

        numAddedImages = 0;
        try {
          const newImages = await ImageService.getGalleryImagesInfo(
            NUM_OF_IMGS,
            listOfNames,
          );
          numAddedImages = newImages.length;
          for (const file of newImages) {
            this.images[file.name] = {
              size: 0,
              url: '',
              wish: file.wish ?? '',
              purpose: file.tags?.purpose ?? '',
            };
            try {
              const fileData = await ImageService.getGalleryImageData(
                file.name,
              );
              this._addImage(file.name, fileData);
            } catch (err) {
              Logger.error(err);
            }
          }
        } catch (error) {
          Logger.error(error);
        }

        this.isLoading = false;
      }

      return numAddedImages;
    },
    _addImage(name, fileData) {
      const image = this.images[name];
      if (image.size < fileData.size) {
        URL.revokeObjectURL(image.url);
        image.size = fileData.size;
        image.url = URL.createObjectURL(fileData);
      }
    },
    getElements(n, numberOfColumns) {
      return Object.keys(this.images)
        .filter((_, index) => index % numberOfColumns === n)
        .map((key) => this.images[key]);
    },
    resetExpanded() {
      this.isExpandedAny = false;
      this.idExpandedImage = -1;
    },
    toggleImage(i) {
      if (!this.isExpandedAny) {
        this.isExpandedAny = !this.isExpandedAny;
        this.idExpandedImage = i;
      }
    },
    previousImage() {
      if (this.idExpandedImage > 0) {
        this.idExpandedImage--;
      }
    },
    nextImage() {
      if (this.idExpandedImage < this.numberOfImages - 1) {
        this.idExpandedImage++;
      } else {
        this.loadImages();
      }
    },
    isWishById(id) {
      const names = Object.keys(this.images);
      return this.images[names[id]].wish && this.images[names[id]].wish !== '';
    },
    isVideoById(id) {
      const names = Object.keys(this.images);
      return (
        this.images[names[id]].purpose &&
        this.images[names[id]].purpose === 'video-gallery'
      );
    },
  },
  getters: {
    numberOfImages: (state) => Object.keys(state.images).length,
    expandedImage: (state) => {
      const names = Object.keys(state.images);
      return state.images[names[state.idExpandedImage]].url;
    },
    expandedName: (state) => {
      const names = Object.keys(state.images);
      return names[state.idExpandedImage];
    },
    wish: (state) => {
      const names = Object.keys(state.images);
      return state.images[names[state.idExpandedImage]].wish;
    },
    isWish: (state) => {
      const names = Object.keys(state.images);
      return (
        state.images[names[state.idExpandedImage]].wish &&
        state.images[names[state.idExpandedImage]].wish !== ''
      );
    },
    isVideo: (state) => {
      const names = Object.keys(state.images);
      return (
        state.images[names[state.idExpandedImage]].purpose &&
        state.images[names[state.idExpandedImage]].purpose === 'video-gallery'
      );
    },
  },
});
